module.exports = __webpack_public_path__ + "media/bdayvoices.7aeb271f.mp3";